import styled from "@emotion/styled";
import { Block as F7Block, Button as F7Button, Segmented } from "framework7-react";
import { useLayoutEffect, useState } from "react";

const DEFAULT_POSITION = 80;

const Block = styled(F7Block)`
  margin-bottom: 1rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${DEFAULT_POSITION}px;
  display: grid;
  gap: 0.5rem;
`;

const Button = styled(F7Button)``;

type ReviewTabBarProps = {
  activeButton: "daily" | "weekly" | "ai";
};

export function ReviewButtonBar({ activeButton }: ReviewTabBarProps) {
  const [bottom, setBottom] = useState(DEFAULT_POSITION);

  useLayoutEffect(() => {
    const toolbar = document.getElementById("app-layout-bottom-toolbar");
    if (!toolbar) return;

    const update = () => setBottom(toolbar.clientHeight);

    const resizeObs = new window.ResizeObserver(update);
    resizeObs.observe(toolbar);
    update();

    return () => resizeObs.disconnect();
  }, []);

  return (
    <Block style={{ bottom, gridTemplateColumns: "1fr" }}>
      <Segmented
        raised
        round
      >
        <Button
          round
          active={activeButton === "daily"}
          href="/review/daily/"
        >
          日別
        </Button>
        <Button
          round
          active={activeButton === "weekly"}
          href="/review/weekly/"
        >
          週別
        </Button>
        <Button
          round
          active={activeButton === "ai"}
          href="/review/ai/"
        >
          評価
        </Button>
      </Segmented>
    </Block>
  );
}
